import axios from "axios";
import { API_BASE_URL } from "../config/constants";

export default axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
